.atm_vy_1osqo2v{width:100%;}
.atm_e2_1osqo2v{height:100%;}
.atm_26_1x778eo{background:white;}
.atm_9s_1txwivl{display:flex;}
.atm_ar_1bp4okc.atm_ar_1bp4okc{flex-direction:column;}
.atm_ks_1wugsn5{overflow:auto;}
.atm_mk_stnw88{position:absolute;}
.atm_tk_idpfg4{top:0;}
.atm_fq_idpfg4{left:0;}
.atm_wq_ifev7s{z-index:10000;}
.atm_3q8tzy_glywfm :focus{outline:none;}
.atm_am_kb7nvz{flex:1;}
.atm_l1_1wugsn5.atm_l1_1wugsn5{overflow-y:auto;}
.atm_l8_exct8b{padding:16px;}
.atm_r3_1e5hqsa{text-align:left;}
.atm_1k0w0t9_i2wt44 ::-webkit-scrollbar{width:6px;}
.atm_1umyded_i2wt44 ::-webkit-scrollbar{height:6px;}
.atm_1rllcl4_j1e0tf.atm_1rllcl4_j1e0tf ::-webkit-scrollbar-thumb{background-color:#CED3DA;}
.atm_1o1igrk_1y44olf ::-webkit-scrollbar-thumb{border-radius:4px;}
.atm_mk_h2mmj6{position:relative;}
.atm_gi_1wugsn5{margin:auto;}
.atm_j3_1h7lqti{max-width:var(--fullscreen-modal-actions-max-width, none);}
.atm_1r_glywfm{-webkit-app-region:none;}
.atm_tk_ftgil2{top:8px;}
.atm_n3_ftgil2{right:8px;}
.atm_wq_kb7nvz{z-index:1;}
